import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';
import LazyLoad from 'react-lazyload';
const Examination = () => {
    useEffect(() => {
        document.title = 'Examination -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>Examination </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>News</li>
                            <li>|</li>
                            <li> Examination </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                     <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 videosearch">
                        <div className="video-gallery">
                            <Link to="#" target="_blank">
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SHSSB/public/Images/examination.png" alt="Sacred Heart School, Ballia - U.P." /> </LazyLoad>
                                  <div> 
                                    <h3> Examination Title </h3>
                                    <p>DD.MM.YY</p>
                                  </div> 
                            </Link>
                        </div>
                    </div>
                </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default Examination